import { Price } from '@/types/Price';

interface GTMItem {
	sku?: string;
	name?: string;
	price?: Price;
	quantity: number;
	brandName?: string;
}

export function mapToGTMItem({ sku, name, price, quantity, brandName }: GTMItem) {
	return {
		item_id: sku,
		item_name: name,
		price: price && price.value / 100,
		quantity,
		...(brandName && { item_brand: brandName }),
	};
}
